import React from 'react';

import PropTypes from 'prop-types';

export default function CheckIcon2({
  color = 'white',
  height = 16,
  width = 16,
  ...rest
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 10 8"
      fill="none"
      {...rest}
    >
      <path
        d="M9.88278 0.690072L3.48307 7.15424C3.44592 7.1918 3.40181 7.2216 3.35325 7.24193C3.30469 7.26226 3.25264 7.27273 3.20008 7.27273C3.14752 7.27273 3.09547 7.26226 3.04691 7.24193C2.99835 7.2216 2.95424 7.1918 2.91709 7.15424L0.117217 4.32616C0.0421643 4.25036 0 4.14754 0 4.04033C0 3.93312 0.0421643 3.8303 0.117217 3.75449C0.19227 3.67868 0.294064 3.63609 0.400205 3.63609C0.506345 3.63609 0.608139 3.67868 0.683192 3.75449L3.20008 6.29723L9.31681 0.118397C9.39186 0.0425887 9.49365 -7.98774e-10 9.59979 0C9.70594 7.98775e-10 9.80773 0.0425887 9.88278 0.118397C9.95783 0.194206 10 0.297025 10 0.404235C10 0.511445 9.95783 0.614263 9.88278 0.690072Z"
        fill={color}
      />
    </svg>
  );
}

CheckIcon2.propTypes = {
  color: PropTypes.string,
  height: PropTypes.number,
  width: PropTypes.number,
};
